import {
    Button,
    Skeleton
} from '@chakra-ui/react';
import React from 'react';

type VideoPlayerProps = {
    onClose: () => void
    src: string
    title: string
};

export const VideoPlayer = ({
    onClose,
    src,
    title
}: VideoPlayerProps) => {
    const chromeOverflowSizeWorkaround = 'calc(100% - 2px)';

    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                height: '100%'
            }}
        >
            {/* SVG for top right corner */}
            <Button
                position={'absolute'}
                top={'10px'}
                right={'10px'}
                w={'64px'}
                h={'64px'}
                flexShrink={0}
                zIndex={1}
                backgroundColor={'transparent'}
                padding={0}
                _hover={{ backgroundColor: 'transparent' }}
                onClick={onClose}
            >
                <svg
                    xmlns={'http://www.w3.org/2000/svg'}
                    width={'64'}
                    height={'64'}
                    viewBox={'0 0 64 64'}
                    fill={'none'}
                >
                    <rect width={'64'} height={'64'} rx={'32'} fill={'#001937'} />
                    <path
                        d={'M48.3164 16.2031L17.2037 47.3158'}
                        stroke={'white'}
                        strokeWidth={'3'}
                        strokeLinecap={'round'}
                    />
                    <path
                        d={'M48.668 47.6689L17.5553 16.5562'}
                        stroke={'white'}
                        strokeWidth={'3'}
                        strokeLinecap={'round'}
                    />
                </svg>
            </Button>

            {/* Video player */}
            <Skeleton
                p={'2px'}
                position={'absolute'}
                w={chromeOverflowSizeWorkaround}
                h={chromeOverflowSizeWorkaround}
                minH={'60vh'}
                borderRadius={'20px'}
            />
            <iframe
                src={src}
                title={title}
                width={'100%'}
                height={'100%'}
                allowFullScreen
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0
                }}
            />
        </div>
    );
};
